export enum LayoutTemplateType {
  Default = 'default',
  Simple = 'simple',
  VoucherShop = 'voucher-shop'
}
